import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { connect, useDispatch } from 'react-redux';
import { getSortedProducts, getSortedProductsNew } from '../../helpers/product';
import ShopSidebar from '../../wrappers/product/ShopSidebar';
import ShopTopbar from '../../wrappers/product/ShopTopbar';
import ShopProducts from '../../wrappers/product/ShopProducts';
import LayoutThree from "../../layouts/LayoutThree";
import { saveUser } from "../../redux/actions/userAction";
import { fetchProductsNoResult, saveProducts } from "../../redux/actions/productsAction";
import { useToasts } from "react-toast-notifications";
import { animateScroll } from "react-scroll";
import Paginator from "../../components/Paginator";
import { useParams } from "react-router-dom";

const ShopGridFullWidth = ({ location, products, userData }) => {
  const isLoggedUser = (((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))) ? true : false;
  const visualizzaPrezzi = isLoggedUser || global.visualizzaPrezziLogOut;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;

  const prodottiSenzaLogin = true;
  const routeParams = useParams();

  const query = new URLSearchParams(location.search);
  const name = query.get('name')
  const { addToast } = useToasts();
  const dispatch = useDispatch()
  const [layout, setLayout] = useState('grid three-column');
  const [sortType, setSortType] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [sortValues, setSortValues] = useState({});
  const [filterSortType, setFilterSortType] = useState('');
  const [filterSortValue, setFilterSortValue] = useState('');
  const [offset, setOffset] = useState(localStorage.getItem("currentPage") ? parseInt(localStorage.getItem("currentPage")) - 1 : 0);
  const [currentPage, setCurrentPage] = useState(localStorage.getItem("currentPage") ? parseInt(localStorage.getItem("currentPage")) : 1);
  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const pageLimit = 42;
  const { pathname } = location;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  var strings = require("../../translations/italian.json");

  const getLayout = (layout) => {
    setLayout(layout)
  }

  useEffect(() => {
    let jNew = {};

    if (!routeParams?.search || routeParams?.search.length === 0) return;
    try {
      jNew = JSON.parse('{"' + decodeURI(routeParams.search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    } catch (error) {
      //console.log(routeParams.search)
    }


    /*const jRouteParams = {"brands": ['JHK','VALENTO'],
                         "category":["GILET"],
                         "subcategory":["ALTA VISIBILITA'"],
                         "templates":["MANICA CORTA", "MANICA LUNGA", "CANOTTA"]};*/

    if (Object.keys(jNew).length === 0) return;
    const { brands, category, subcategory, templates, tag } = jNew;
    const _brands = !brands ? [] : JSON.parse('["' + brands.replaceAll('+', ' ').replaceAll('%2C', '", "') + '"' + ']');
    const _category = !category ? [] : JSON.parse('["' + category.replaceAll('+', ' ').replaceAll('%2C', '", "') + '"' + ']');
    const _subcategory = !subcategory ? [] : JSON.parse('["' + subcategory.replaceAll('+', ' ').replaceAll('%2C', '", "') + '"' + ']');
    const _templates = !templates ? [] : JSON.parse('["' + templates.replaceAll('+', ' ').replaceAll('%2C', '", "') + '"' + ']');
    const _tag = !tag ? [] : JSON.parse('["' + tag.replaceAll('+', ' ').replaceAll('%2C', '", "') + '"' + ']');

    let sBrands = '';
    let sCategory = '';
    let sSubcategory = '';
    let sTemplates = '';
    let sTag = '';

    if (_brands?.forEach) _brands.forEach(element => sBrands += "|" + element);
    if (_category?.forEach) _category.forEach(element => sCategory += "|" + element);
    if (_subcategory?.forEach) _subcategory.forEach(element => sSubcategory += "|" + element);
    if (_templates?.forEach) _templates.forEach(element => sBrands += "|" + element);
    if (_tag?.forEach) _tag.forEach(element => sTag += "|" + element);

    if (sBrands.length > 0) sBrands = sBrands.substr(1);
    if (sCategory.length > 0) sCategory = sCategory.substr(1);
    if (sSubcategory.length > 0) sSubcategory = sSubcategory.substr(1);
    if (sTemplates.length > 0) sTemplates = sTemplates.substr(1);
    if (sTag.length > 0) sTag = sTag.substr(1);

    let newJRouteParams = {};
    if (sBrands.length > 0) newJRouteParams.brands = sBrands;
    if (sCategory.length > 0) newJRouteParams.category = sCategory;
    if (sSubcategory.length > 0) newJRouteParams.subcategory = sSubcategory;
    if (sTemplates.length > 0) newJRouteParams.templates = sTemplates;
    if (sTag.length > 0) newJRouteParams.tag = sTag;

    const newFilterString = JSON.stringify(newJRouteParams);
    const oldFilterString = sessionStorage.getItem('filter') || '';

    if (newFilterString === oldFilterString) return;

    sessionStorage.setItem("filter", newFilterString);
    setSortValues(newJRouteParams);
    sessionStorage.setItem("currentPage", 1)
    setCurrentPage(1)
    setRefresh(!refresh);
  }, [routeParams, query]);

  const getSortParams = (sortType, sortValue, type) => {
    setSortType(sortType);
    setSortValue(sortValue);
    var sortValuesLocal = sortValues;
    if (sortValuesLocal) sortValuesLocal[sortType] = sortValuesLocal[sortType] ? sortValuesLocal[sortType].replace("all", "") : ""
    if (sortValue == "all" && type == "+") sortValuesLocal[sortType] = "all"
    else if (type == "+") sortValuesLocal[sortType] = sortValuesLocal[sortType] ? sortValuesLocal[sortType] + "|" + sortValue : sortValue
    else if (type == "-") sortValuesLocal[sortType] = sortValuesLocal[sortType].replace("|" + sortValue, "").replace(sortValue + "|", "").replace(sortValue, "")
    if (sortValuesLocal[sortType] == "") delete sortValuesLocal[sortType]
    sessionStorage.setItem("filter", JSON.stringify(sortValuesLocal))
    //console.log(sortValuesLocal)
    setSortValues(sortValuesLocal)
    setRefresh(!refresh)
    sessionStorage.setItem("currentPage", 1)
    setCurrentPage(1)
  }

  const getFilterSortParams = (sortType, sortValue) => {
    setFilterSortType(sortType);
    setFilterSortValue(sortValue);
  }

  useEffect(() => {
    if (global.inManutenzione) {
      //setShowDialogUpdate(false)
      return
    }
    const time = Date.now() - sessionStorage.getItem("lastRefresh")
    if (Date.now() - sessionStorage.getItem("lastRefresh") > global.thrUpdPro) {
      if (((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge)) || prodottiSenzaLogin) {
        var credentials = {};
        var username = '';
        var password = '';

        if (((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge))) {
          var username = userData.user.user.username;
          var password = userData.user.user.password;
          credentials = { username, password };
        }

        var risultatoProducts = fetchProductsNoResult({ ...credentials, recommended: userData?.user?.user?.jsonVendite })

        //saveProducts(risultatoProducts, addToast)
        risultatoProducts
          .then((res) => res.json())
          .then(
            (result) => {
              if (!result.items) {
                try {
                  const { recommended } = userData?.user.user.jsonVendite;
                  const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                  const recommendedProducts = !recommended ?
                    undefined :
                    recommended.map(_r => itemsFromAPI?.find(_item => _item.id === _r.idArtBas) || null).filter(_rr => !!_rr?.id);
                  result.items = !recommended
                    ? [...itemsFromAPI]
                    : [...recommendedProducts, ...itemsFromAPI];
                  result.itemsNoParsed = '';
                } catch (error) {
                  console.log(error);
                }
              }

              sessionStorage.setItem("lastRefresh", Date.now())
              //console.log(result)
              //console.log(result)
              dispatch(saveProducts(result, addToast))
              //closeDialogUpdate()
            }
          )
      }
      else {
        var risultatoProducts = fetchProductsNoResult({})
        //saveProducts(risultatoProducts, addToast)
        risultatoProducts
          .then((res) => res.json())
          .then(
            (result) => {
              if (!result.items) {
                try {
                  const { recommended } = userData?.user.user.jsonVendite;
                  const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                  const recommendedProducts = !recommended ?
                    undefined :
                    recommended.map(_r => itemsFromAPI?.find(_item => _item.id === _r.idArtBas) || null).filter(_rr => !!_rr?.id);
                  result.items = !recommended
                    ? [...itemsFromAPI]
                    : [...recommendedProducts, ...itemsFromAPI];
                  result.itemsNoParsed = '';
                } catch (error) {
                  console.log(error);
                }
              }

              sessionStorage.setItem("lastRefresh", Date.now())
              //console.log(result)
              //console.log(result)
              dispatch(saveProducts(result, addToast))
              //closeDialogUpdate()
            }
          )
      }
    }
    else {
      //closeDialogUpdate()
    }
    const timer = setInterval(() => {
      if (((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge)) || prodottiSenzaLogin) {
        //setShowDialogUpdate(true);
        var credentials = {};
        var username = '';
        var password = '';

        if (((userData.user.user) && (userData.user.user.IDCli || userData.user.user.IDAge))) {
          var username = userData.user.user.username;
          var password = userData.user.user.password;
          credentials = { username, password };
        }

        var risultatoProducts = fetchProductsNoResult({ ...credentials, recommended: userData?.user?.user?.jsonVendite })
        //console.log(risultatoProducts)
        risultatoProducts
          .then((res) => res.json())
          .then(
            (result) => {
              if (!result.items) {
                try {
                  const { recommended } = userData?.user.user.jsonVendite;
                  const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                  const recommendedProducts = !recommended ?
                    undefined :
                    recommended.map(_r => itemsFromAPI?.find(_item => _item.id === _r.idArtBas) || null).filter(_rr => !!_rr?.id);
                  result.items = !recommended
                    ? [...itemsFromAPI]
                    : [...recommendedProducts, ...itemsFromAPI];
                  result.itemsNoParsed = '';
                } catch (error) {
                  console.log(error);
                }
              }

              sessionStorage.setItem("lastRefresh", Date.now())
              //console.log(result)
              //console.log(result)
              dispatch(saveProducts(result, addToast))
              //closeDialogUpdate()
            }
          )

      }
      else {
        var risultatoProducts = fetchProductsNoResult({})
        //console.log(risultatoProducts)
        risultatoProducts
          .then((res) => res.json())
          .then(
            (result) => {

              if (!result.items) {
                try {
                  const { recommended } = userData?.user.user.jsonVendite;
                  const itemsFromAPI = JSON.parse(result?.itemsNoParsed);
                  const recommendedProducts = !recommended ?
                    undefined :
                    recommended.map(_r => itemsFromAPI?.find(_item => _item.id === _r.idArtBas) || null).filter(_rr => !!_rr?.id);
                  result.items = !recommended
                    ? [...itemsFromAPI]
                    : [...recommendedProducts, ...itemsFromAPI];
                  result.itemsNoParsed = '';
                } catch (error) {
                  console.log(error);
                }
              }

              sessionStorage.setItem("lastRefresh", Date.now())
              ////console.log(result)
              //console.log(result)
              dispatch(saveProducts(result, addToast))
              //closeDialogUpdate()
            }
          )
      }
    }, global.thrUpdPro)
    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    const isConsigliati = window.location.pathname === '/consigliati' ? true : false;
    const _cp = (localStorage.getItem("currentPage") ? parseInt(localStorage.getItem("currentPage")) : 1);

    if (_cp != currentPage) {
        setCurrentPage(_cp);
    }
    const product6 = (products && products.length >= 49) ? products.slice(0, 49) : products;
    const _products = isConsigliati ? product6 : products;
    let sortedProducts = getSortedProductsNew(_products, sortValues);
    const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
    sortedProducts = filterSortedProducts;
    setSortedProducts(sortedProducts);
    setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue, sortValues, refresh]);

  useEffect(() => {
    if (name != null && name != "") {
      setFilterSortType("name, sku")
      setFilterSortValue(name)
      sessionStorage.setItem("currentPage", 1)
      setCurrentPage(1)
    }
    setSortValues(JSON.parse(sessionStorage.getItem("filter")) ? JSON.parse(sessionStorage.getItem("filter")) : {})
    setRefresh(!refresh)
  }, [])

  return (
    <Fragment>
      <MetaTags>
        <title>{strings.shop} | {strings.titleSite}</title>
        <meta
          name="description"
          content={strings.shop + " " + strings.siteContent}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + '/'}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>Acquista</BreadcrumbsItem>
      {/*<ModalUpdate />*/}
      {/*new Date(2023, 11, 1).getTime() > new Date().getTime() ? <ModalNovember8 /> : <ModalDecember8 />*/}

      <LayoutThree headerTop="invisible" getSortParams={getSortParams}>
        {/* breadcrumb */}

        <div className="shop-area pt-95 pb-100">
          <div className="container-fluid" style={{ paddingLeft: '20px' }}>
            <div className="row">
              <div className="col-lg-2 order-2 order-lg-1" style={{ overflowY: 'auto', maxHeight: '830px' }}>
                {/* shop sidebar */}
                <ShopSidebar products={products} getSortParams={getSortParams} setSortValues={setSortValues} value={name} />
              </div>
              <div className="col-lg-10 order-1 order-lg-2">
                {/* shop topbar default */}
                <ShopTopbar
                  setSortValues={setSortValues}
                  getSortParams={getSortParams} value={name} userData={userData} getLayout={getLayout}
                  getFilterSortParams={getFilterSortParams} productCount={sortedProducts.length}
                  sortedProductCount={currentData.length} offset={offset} />

                {/* shop page content default */}
                <ShopProducts
                  isLoggedUser={isLoggedUser}
                  visualizzaPrezzi={visualizzaPrezzi}
                  layout={layout}
                  products={currentData} />


                {/* shop product pagination */}
                <div className="pro-pagination-style text-center mt-30">
                  <Paginator
                    totalRecords={sortedProducts.length}
                    pageLimit={pageLimit}
                    pageNeighbours={2}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={(page) => {
                      setCurrentPage(page)
                      localStorage.setItem("currentPage", page)
                      animateScroll.scrollToTop();
                    }
                    }
                    pageContainerClass="mb-0 mt-0"
                    pagePrevText="«"
                    pageNextText="»"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutThree>
    </Fragment>
  )
}

ShopGridFullWidth.propTypes = {
  location: PropTypes.object,
  products: PropTypes.array
}

const mapStateToProps = state => {
  return {
    products: state.productData.products,
    userData: state.userData
  }
}

const mapDispatchToProps = dispatch => {

  return {
    saveUser: (user, addToast) => { dispatch(saveUser(user, addToast)) },
    saveProducts: (products, addToast) => { dispatch(saveProducts(products, addToast)) }

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ShopGridFullWidth);